import { route } from 'constant'

export const routesWithoutSidebar = [route.userManagementCreate]
